import React from 'react';

export default ({ shouldRender, containerClassName, children }) => {
    let component = null;

    if (shouldRender) {
        if (containerClassName) {
            component = <div className={containerClassName}>{children}</div>;
        } else {
            component = children;
        }
    }

    return component;
};
